/**
 * Booléens Produit historiquement éditables via « Badges alimentaires »,
 * désormais dérivés côté API depuis les caractéristiques (SLUG_TO_BOOL).
 *
 * Miroir volontaire du mapping backend
 * (`backend/services/caracteristiqueService.js` → SLUG_TO_BOOL).
 * Ne pas inventer de couple slug→champ hors de ce mapping.
 */

/** Champs booléens réellement synchronisés par le moteur M1. */
export const LEGACY_BOOL_FIELDS = [
  'bio',
  'local',
  'vegan',
  'vegetarien',
  'sansGluten',
  'directProducteur',
  'epice',
  'sansLactose',
  'sansArachides',
  'sansPoisson',
];

/** Libellés canoniques pour créer la caractéristique correspondante. */
export const LEGACY_BOOL_CANONICAL_LABEL = {
  bio: 'Bio',
  local: 'Local',
  vegan: 'Vegan',
  vegetarien: 'Végétarien',
  sansGluten: 'Sans gluten',
  directProducteur: 'Direct Producteur',
  epice: 'Épicé',
  sansLactose: 'Sans lactose',
  sansArachides: 'Sans arachides',
  sansPoisson: 'Sans poisson',
};

/**
 * slugNormalise → champ Produit (copie du backend).
 * Inclut les variantes sans espace déjà reconnues par l’API.
 */
export const SLUG_TO_BOOL = {
  bio: 'bio',
  local: 'local',
  vegan: 'vegan',
  vegetarien: 'vegetarien',
  'sans gluten': 'sansGluten',
  sansgluten: 'sansGluten',
  'direct producteur': 'directProducteur',
  directproducteur: 'directProducteur',
  epice: 'epice',
  'sans lactose': 'sansLactose',
  sanslactose: 'sansLactose',
  'sans arachides': 'sansArachides',
  sansarachides: 'sansArachides',
  'sans poisson': 'sansPoisson',
  sanspoisson: 'sansPoisson',
};

/** Même règles que backend/utils/normalizeForMatch (miroir Admin). */
export function normalizeForMatch(input) {
  if (input == null) return '';
  if (typeof input !== 'string') {
    if (typeof input === 'number' || typeof input === 'boolean') {
      input = String(input);
    } else {
      return '';
    }
  }
  return input
    .trim()
    .toLowerCase()
    .replace(/œ/g, 'oe')
    .replace(/æ/g, 'ae')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Retire les booléens dérivés d’un payload create/update produit. */
export function omitLegacyBoolFields(payload) {
  if (!payload || typeof payload !== 'object') return payload;
  const next = { ...payload };
  for (const field of LEGACY_BOOL_FIELDS) {
    delete next[field];
  }
  return next;
}

/**
 * Booléens actifs en base sans caractéristique couvrant le slug.
 * À afficher en lecture / reprise — pas de backfill automatique.
 *
 * @param {{ caracteristiques?: Array<{ label?: string }>, [key: string]: unknown }} produit
 * @returns {{ field: string, label: string }[]}
 */
export function listUncoveredLegacyBools(produit) {
  if (!produit || typeof produit !== 'object') return [];

  const covered = new Set();
  for (const item of produit.caracteristiques || []) {
    const slug = normalizeForMatch(item?.label);
    const field = SLUG_TO_BOOL[slug];
    if (field) covered.add(field);
  }

  return LEGACY_BOOL_FIELDS.filter((field) => Boolean(produit[field]) && !covered.has(field)).map(
    (field) => ({
      field,
      label: LEGACY_BOOL_CANONICAL_LABEL[field],
    }),
  );
}
